var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeforeHiddenImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4983 7.85351C10.2141 7.60091 9.7859 7.60091 9.50173 7.85351L2.83219 13.782C2.6258 13.9654 2.30976 13.9469 2.1263 13.7405C1.94284 13.5341 1.96143 13.218 2.16782 13.0346L8.83737 7.1061C9.50042 6.51672 10.4996 6.51672 11.1626 7.1061L17.8322 13.0346C18.0386 13.218 18.0572 13.5341 17.8737 13.7405C17.6903 13.9469 17.3742 13.9654 17.1678 13.782L10.4983 7.85351Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeforeHiddenImage);
export default __webpack_public_path__ + "static/media/beforeHiddenImage.3a5402550f286fa55fb6cd31e6fb7974.svg";
export { ForwardRef as ReactComponent };